import { ReactNode, useMemo } from 'react';
import styles from './link.module.scss';

type LinkProps = {
  to: string;
  children: ReactNode;
  openNewTab?: boolean;
  color?: string;
  underlined?: boolean;
  disableHoverInteraction?: boolean;
  className?: string;
};

export function Link({
  to,
  children,
  openNewTab,
  color = 'primary-dark',
  underlined,
  disableHoverInteraction,
  className = '',
}: LinkProps) {
  const linkClassName = useMemo(() => {
    let linkClassName = `${className} ${styles[color]}`;
    if (underlined) {
      linkClassName = linkClassName.concat(' is-underlined');
    }
    if (!disableHoverInteraction) {
      linkClassName = linkClassName.concat(` ${styles.container}`);
    }
    return linkClassName;
  }, [className, color, disableHoverInteraction, underlined]);

  return (
    <a
      href={to}
      className={linkClassName}
      target={openNewTab ? '_blank' : undefined}
      rel={openNewTab ? 'noopener noreferrer' : undefined}
      onClick={(e) => e.stopPropagation()}
    >
      {children}
    </a>
  );
}

export default Link;
